import { render, staticRenderFns } from "./WtSide.vue?vue&type=template&id=f9daf958"
import script from "./WtSide.vue?vue&type=script&lang=js"
export * from "./WtSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports